import React from 'react'

import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material'

import { FplDialogTitle } from 'components/common/Dialog'
import { useGetBookingLogQuery } from 'generated/graphql'

interface IProps {
  selectedLogRecordId: number | null
  openDialog: boolean
  handleCloseDialog: () => any
}

const ViewLogRecord = (props: IProps) => {
  const { selectedLogRecordId, openDialog, handleCloseDialog } = props
  const [title, setTitle] = React.useState<string>('')
  const [data, setData] = React.useState<string>('')

  const { loading } = useGetBookingLogQuery({
    variables: {
      bookingLogId: selectedLogRecordId,
    },
    onCompleted: (data) => {
      setTitle(`${data?.bookingLog?.type}`)
      setData(`Details: ${data?.bookingLog?.details}`)
    },
  })

  const handleClose = () => {
    handleCloseDialog()
  }

  return (
    <Dialog
      fullWidth
      maxWidth='md'
      open={openDialog}
      onClose={handleCloseDialog}
      aria-labelledby='form-contact-dialog-title'>
      <FplDialogTitle id='form-contact-dialog-title' onClose={handleClose}>
        <Typography paragraph variant='h4'>
          {title}
        </Typography>
      </FplDialogTitle>

      <DialogContent>
        <Box>
          <Typography>Audit Record ID: {selectedLogRecordId}</Typography>
        </Box>
        {loading ? (
          <Box component='div' height={200} width='100%' display='flex' justifyContent='center'>
            <CircularProgress size={150} style={{ marginTop: 10 }} variant='indeterminate' />
          </Box>
        ) : (
          <Box>{data}</Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button variant='contained' onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ViewLogRecord
